export const ProductsBySupplierProduct = (data: IProductsBySupplierProduct): IProductsBySupplierProductModel => {
	const {
		delivery_deadline,
		item_id,
		logistic_minimum_amount,
		raw_material_id,
		raw_material_name,
		total_price,
		unit_price,
		declared_quantity,
		category,
		supplier_name,
		price_per_unit,
		conversion_factor,
		delivery_price,
		package_content_net,
		is_product_completed,
		...rest
	} = data

	return {
		...rest,
		deliveryDeadline: delivery_deadline,
		itemId: item_id,
		logisticMinimumAmount: logistic_minimum_amount,
		rawMaterialId: raw_material_id,
		rawMaterialName: raw_material_name,
		totalPrice: total_price,
		unitPrice: unit_price,
		declaredQuantity: declared_quantity,
		category: category ?? '-',
		supplierName: supplier_name ?? raw_material_name,
		pricePerUnit: price_per_unit ?? null,
		conversionFactor: conversion_factor ?? null,
		deliveryPrice: delivery_price ?? null,
		packageContentNet: package_content_net ?? null,
		isProductCompleted: is_product_completed ?? false,
	}
}

export const ProductsBySupplier = (data: IProductsBySupplier): IProductsBySupplierModel => {
	const {
		id,
		name,
		products,
		total_price,
		delivery_deadline,
		supplier,
		total_amount,
		average_coverage,
		supplier_order_sequence,
		supplier_order_number,
		...rest
	} = data

	return {
		...rest,
		id: id ?? null,
		name,
		deliveryDeadline: delivery_deadline,
		products: products?.map(product => ProductsBySupplierProduct(product)) ?? [],
		totalPrice: total_price,
		supplier: ProductsBySupplierSupplier(supplier),
		totalAmount: total_amount,
		averageCoverage: average_coverage,
		supplierOrderSequence: supplier_order_sequence ?? 1,
		supplierOrderNumber: supplier_order_number ?? null,
		summaryKey: `${supplier.id}-${supplier_order_sequence ?? 1}`,
	}
}
